export default function YoutubeIcon() {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0924 2.04785H2.90762C1.30178 2.04785 0 3.34964 0 4.95547V9.04699C0 10.6528 1.30178 11.9546 2.90762 11.9546H11.0924C12.6982 11.9546 14 10.6528 14 9.04699V4.95547C14 3.34964 12.6982 2.04785 11.0924 2.04785ZM9.12598 7.2003L5.2977 9.02615C5.19569 9.0748 5.07786 9.00043 5.07786 8.88743V5.12159C5.07786 5.00698 5.19879 4.9327 5.30101 4.9845L9.12929 6.92449C9.24311 6.98216 9.24113 7.14539 9.12598 7.2003Z"
        fill="#F0F3F9"
      />
    </svg>
  );
}
